module.exports = __webpack_public_path__ + "static/img/12.5d033e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutus/12.jpg
// module id = la51
// module chunks = 1